module.exports = "/_next/static/images/p_cross-1c4c646b79dd0d5e2e83cc045c499228.png";